import { render, staticRenderFns } from "./cleaning-supply-list.vue?vue&type=template&id=2398338a"
import script from "./cleaning-supply-list.vue?vue&type=script&lang=js"
export * from "./cleaning-supply-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports